export enum ApiEnum {
  AIRCRAFT_API = 'AIRCRAFT_API',
  OPERATOR_API = 'OPERATOR_API',
  SOURCING_API = 'SOURCING_API'
}
